import { NormalizedNumber } from '@sparkdotfi/common-universal'

import { NormalizedConvertStablesFormValues } from '../../types'
import type { ConvertStablesFormSchema } from './schema'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'

export interface NormalizeFormValuesParams {
  formValues: ConvertStablesFormSchema
  tokenRepository: TokenRepository
}

export function normalizeFormValues({
  formValues,
  tokenRepository,
}: NormalizeFormValuesParams): NormalizedConvertStablesFormValues {
  const from = tokenRepository.findOneBySymbol(formValues.from)
  const to = tokenRepository.findOneBySymbol(formValues.to)
  const amount = NormalizedNumber(formValues.amount === '' ? '0' : formValues.amount)

  return {
    from,
    to,
    amount,
  }
}

export function getNormalizedFormValuesKey(values: NormalizedConvertStablesFormValues): string {
  return [values.from.address, values.to.address, values.amount.toFixed()].join('-')
}
